import React from 'react';
import {
  Typography,
  Button,
  Row as GridRow,
  Col,
} from 'design-system';
import { PlusIcon } from '../../../design-system/components/Icons';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

export default function ButtonShowcase() {
  return (
    <>
      {/* Button Section */}
      <GridRow>
          <Col xs={12}>
            <div className="design-system-section">
              <Typography variant="h1" className="section-title mb-4">
                Buttons
              </Typography>
              <Separator className="mb-5" />

              <section className="ds-figma-buttons-section" aria-labelledby="figma-buttons-size">
                <h2 id="figma-buttons-size" className="ds-figma-buttons-section-title">
                  Buttons size
                </h2>
                <div className="ds-figma-buttons-tiles">
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="primary" size="base">
                        Create task
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">Size = Medium</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="primary" size="l">
                        Create task
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">Size = Large</span>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-buttons-state-primary">
                <h2 id="figma-buttons-state-primary" className="ds-figma-buttons-section-title">
                  Buttons state â€” Primary
                </h2>
                <div className="ds-figma-buttons-tiles">
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="primary" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Default</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-hover-primary">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="primary" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Hover</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="primary" size="l" icon={<PlusIcon size={20} />} disabled>
                        Create task
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Disable</span>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-primary-types">
                <h2 id="figma-primary-types" className="ds-figma-buttons-section-title">
                  Primary buttons type
                </h2>
                <div className="ds-figma-buttons-types-grid">
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Text only</span>
                    <Button variant="primary" size="l">
                      Create task
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Text + left icon</span>
                    <Button variant="primary" size="l" icon={<PlusIcon size={20} />}>
                      Create task
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Text + right icon</span>
                    <Button variant="primary" size="l" icon={<PlusIcon size={20} />} iconPosition="right">
                      Create task
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Icon only</span>
                    <Button variant="primary" size="l" icon={<PlusIcon size={20} />} aria-label="Create task" />
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-secondary-types">
                <h2 id="figma-secondary-types" className="ds-figma-buttons-section-title">
                  Secondary buttons type
                </h2>
                <div className="ds-figma-buttons-types-grid">
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Text only</span>
                    <Button variant="secondary" size="l">
                      Create task
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Text + left icon</span>
                    <Button variant="secondary" size="l" icon={<PlusIcon size={20} />}>
                      Create task
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Text + right icon</span>
                    <Button variant="secondary" size="l" icon={<PlusIcon size={20} />} iconPosition="right">
                      Create task
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Icon only</span>
                    <Button variant="secondary" size="l" icon={<PlusIcon size={20} />} aria-label="Create task" />
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-linear-types">
                <h2 id="figma-linear-types" className="ds-figma-buttons-section-title">
                  Linear buttons type
                </h2>
                <div className="ds-figma-buttons-linear-rows">
                  <h3 className="ds-figma-buttons-row-heading">Gradient (filled)</h3>
                  <div className="ds-figma-buttons-types-grid">
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text only</span>
                      <Button variant="linear" size="l">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + left icon</span>
                      <Button variant="linear" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + right icon</span>
                      <Button variant="linear" size="l" icon={<PlusIcon size={20} />} iconPosition="right">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Icon only</span>
                      <Button variant="linear" size="l" icon={<PlusIcon size={20} />} aria-label="Create task" />
                    </div>
                  </div>
                  <h3 className="ds-figma-buttons-row-heading">White</h3>
                  <div className="ds-figma-buttons-types-grid">
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text only</span>
                      <Button variant="linear-outline" size="l">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + left icon</span>
                      <Button variant="linear-outline" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + right icon</span>
                      <Button variant="linear-outline" size="l" icon={<PlusIcon size={20} />} iconPosition="right">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Icon only</span>
                      <Button
                        variant="linear-outline"
                        size="l"
                        icon={<PlusIcon size={20} />}
                        aria-label="Create task"
                      />
                    </div>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-tertiary-states">
                <h2 id="figma-tertiary-states" className="ds-figma-buttons-section-title">
                  Tertiary button states
                </h2>
                <div className="ds-figma-buttons-tiles">
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="tertiary" size="l">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Default</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-hover-tertiary">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="tertiary" size="l">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Hover</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-focus-tertiary">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="tertiary" size="l">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Focus</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="tertiary" size="l" disabled>
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Disable</span>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-link-states">
                <h2 id="figma-link-states" className="ds-figma-buttons-section-title">
                  Link button states
                </h2>
                <div className="ds-figma-buttons-tiles">
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="link" size="base">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Default</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-hover-link">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="link" size="base">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Hover</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-focus-link">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="link" size="base">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Focus</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="link" size="base" disabled>
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Disable</span>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-link-primitive-buttons">
                <h2 id="figma-link-primitive-buttons" className="ds-figma-buttons-section-title">
                  Link button (primitives)
                </h2>
                <div className="ds-figma-buttons-types-grid">
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Text (inherits)</span>
                    <Button variant="link" type="button" onClick={() => {}}>
                      View details
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Styled as link</span>
                    <Button variant="link" type="button" className="ds-design-system-link-demo-link" onClick={() => {}}>
                      Learn more
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Icon + label</span>
                    <Button
                      variant="link"
                      type="button"
                      className="ds-design-system-link-demo-chip"
                      icon={<PlusIcon size={14} />}
                      iconPosition="left"
                      onClick={() => {}}
                    >
                      Add item
                    </Button>
                  </div>
                  <div className="ds-figma-buttons-type-cell">
                    <span className="ds-figma-buttons-type-label">Icon only</span>
                    <Button
                      variant="link"
                      type="button"
                      className="ds-design-system-link-demo-icon"
                      aria-label="Close"
                      onClick={() => {}}
                    >
                      <span aria-hidden>Ã—</span>
                    </Button>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-tag-buttons">
                <h2 id="figma-tag-buttons" className="ds-figma-buttons-section-title">
                  Tag buttons
                </h2>
                <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                  Purple
                </Typography>
                <div className="ds-figma-buttons-tag-row mb-4">
                  <Button variant="tag-purple" size="sm">
                    134
                  </Button>
                  <Button variant="tag-purple" size="base">
                    134
                  </Button>
                  <Button variant="tag-purple" size="l">
                    134
                  </Button>
                </div>
                <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                  Blue
                </Typography>
                <div className="ds-figma-buttons-tag-row">
                  <Button variant="tag-blue" size="sm">
                    134
                  </Button>
                  <Button variant="tag-blue" size="base">
                    134
                  </Button>
                  <Button variant="tag-blue" size="l">
                    134
                  </Button>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-positive-negative">
                <h2 id="figma-positive-negative" className="ds-figma-buttons-section-title">
                  Positive &amp; negative
                </h2>
                <Typography variant="subtitle1" className="mb-2">
                  Positive
                </Typography>
                <div className="ds-figma-buttons-tiles mb-4">
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="positive" size="l">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Default</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-hover-positive">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="positive" size="l">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Hover</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-focus-positive">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="positive" size="l">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Focus</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="positive" size="l" disabled>
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Disable</span>
                  </div>
                </div>
                <Typography variant="subtitle1" className="mb-2">
                  Negative
                </Typography>
                <div className="ds-figma-buttons-tiles">
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="danger" size="base">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Default</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-hover-negative">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="danger" size="base">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Hover</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-focus-negative">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="danger" size="base">
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Focus</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="danger" size="base" disabled>
                        Continue
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Disable</span>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-loading">
                <h2 id="figma-loading" className="ds-figma-buttons-section-title">
                  Loading button states
                </h2>
                <div className="ds-figma-buttons-tiles">
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="secondary" size="base" loading aria-label="Loading" />
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Loading</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="primary" size="base" loading aria-label="Loading" />
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Loading</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="positive" size="base" loading aria-label="Loading" />
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Loading</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="danger" size="base" loading aria-label="Loading" />
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Loading</span>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-buttons-state-circular">
                <h2 id="figma-buttons-state-circular" className="ds-figma-buttons-section-title">
                  Buttons state â€” Circular
                </h2>
                <div className="ds-figma-buttons-tiles">
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="circular-primary" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Default</span>
                  </div>
                  <div className="ds-figma-buttons-tile ds-figma-buttons-tile--sim-hover-circular-primary">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="circular-primary" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Hover</span>
                  </div>
                  <div className="ds-figma-buttons-tile">
                    <div className="ds-figma-buttons-tile__preview">
                      <Button variant="circular-primary" size="l" icon={<PlusIcon size={20} />} disabled>
                        Create task
                      </Button>
                    </div>
                    <span className="ds-figma-buttons-tile__label">State = Disable</span>
                  </div>
                </div>
              </section>

              <section className="ds-figma-buttons-section" aria-labelledby="figma-circular-types">
                <h2 id="figma-circular-types" className="ds-figma-buttons-section-title">
                  Circular buttons type
                </h2>
                <div className="ds-figma-buttons-linear-rows">
                  <h3 className="ds-figma-buttons-row-heading">Outline</h3>
                  <div className="ds-figma-buttons-types-grid">
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text only</span>
                      <Button variant="circular" size="l">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + left icon</span>
                      <Button variant="circular" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + right icon</span>
                      <Button variant="circular" size="l" icon={<PlusIcon size={20} />} iconPosition="right">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Icon only</span>
                      <Button variant="circular" size="l" icon={<PlusIcon size={20} />} aria-label="Create task" />
                    </div>
                  </div>
                  <h3 className="ds-figma-buttons-row-heading">Primary filled</h3>
                  <div className="ds-figma-buttons-types-grid">
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text only</span>
                      <Button variant="circular-primary" size="l">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + left icon</span>
                      <Button variant="circular-primary" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + right icon</span>
                      <Button variant="circular-primary" size="l" icon={<PlusIcon size={20} />} iconPosition="right">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Icon only</span>
                      <Button
                        variant="circular-primary"
                        size="l"
                        icon={<PlusIcon size={20} />}
                        aria-label="Create task"
                      />
                    </div>
                  </div>
                  <h3 className="ds-figma-buttons-row-heading">Tertiary filled</h3>
                  <div className="ds-figma-buttons-types-grid">
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text only</span>
                      <Button variant="circular-tertiary" size="l">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + left icon</span>
                      <Button variant="circular-tertiary" size="l" icon={<PlusIcon size={20} />}>
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Text + right icon</span>
                      <Button variant="circular-tertiary" size="l" icon={<PlusIcon size={20} />} iconPosition="right">
                        Create task
                      </Button>
                    </div>
                    <div className="ds-figma-buttons-type-cell">
                      <span className="ds-figma-buttons-type-label">Icon only</span>
                      <Button
                        variant="circular-tertiary"
                        size="l"
                        icon={<PlusIcon size={20} />}
                        aria-label="Create task"
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </Col>
      </GridRow>
    </>
  );
}
